import { gql } from '@apollo/client';
import React from 'react';
import { PdpInfoContainerFragment } from '../../generated/types/PdpInfoContainerFragment';
import { Availability } from '../../constants';
import { PdpTrunkshowInfo } from './PdpTrunkshowInfo';
import { PdpDeliveryInfo } from './PdpDeliveryInfo';
import { formatDeliveryDate } from './formatDeliveryDate';

import './PdpInfoContainer.scss';

interface Props {
  variant: PdpInfoContainerFragment;
}

export const PDP_INFO_MODULE_FRAGMENT = gql`
  fragment PdpInfoContainerFragment on Variant {
    id
    availability
    masterVariant: master_variants_data {
      processDeliveryDates: process_delivery_dates {
        deliveryStartsOn: delivery_starts_on
        deliveryEndsOn: delivery_ends_on
      }
    }
    trunkshows {
      edges {
        node {
          id
          name
          slug
          seasonName: season_name
          activeStartI: active_start_i
          activeEndI: active_end_i
        }
      }
    }
  }
`;

export const PdpInfoContainer: React.FC<Props> = ({ variant }) => {
  if (!variant?.trunkshows?.edges) {
    return null;
  }

  const trunkshow = variant?.trunkshows?.edges[0]?.node;
  const trunkshowDate = variant.masterVariant.processDeliveryDates?.deliveryEndsOn;
  const trunkshowDateNew = trunkshowDate != null ? new Date(trunkshowDate) : null;

  const shippingDateFormatted = trunkshowDateNew ? formatDeliveryDate(trunkshowDateNew) : undefined;
  return (
    <div className="PdpInfoContainer" data-testid="infoModuleSection">
      {variant.availability === String(Availability.Trunkshow) && trunkshow && (
        <PdpTrunkshowInfo trunkshow={trunkshow} shippingDateFormatted={shippingDateFormatted} />
      )}

      {variant.availability === String(Availability.Preorder) && (
        <PdpDeliveryInfo deliveryDates={variant.masterVariant.processDeliveryDates} />
      )}
    </div>
  );
};
